import { createStyles } from '@mantine/styles';


export default createStyles((
    theme: {
        colors: { [x: string]: any[] };
        other: any;
        spacing: any;
        colorScheme: any;
        shadows: any;
        radius: any;
        fn: any;
    }) => ({

    h1: {
        fontSize: 28,
        letterSpacing: 0.6,
        color: theme.colorScheme === 'dark' ? theme.colors.gray[0] : theme.colors.dark[4],

        [theme.fn.smallerThan('sm')]: {
            fontSize: 18,
        },

    },

    h2: {
        letterSpacing: 0.6,
        color: theme.colorScheme === 'dark' ? theme.colors.gray[5] : theme.colors.dark[4],

        [theme.fn.smallerThan('sm')]: {
            fontSize: 14,
        },

    },

    titleLocation: {
        display: 'inline-flex',
        gap: theme.spacing.xs,
        flexWrap: 'nowrap',

        [theme.fn.smallerThan('sm')]: {
            // fontSize: 18,
            // height: 23,
            // alignItems: 'flex-start',
            // overflow: 'hidden',
            flexWrap: 'nowrap',
        },
    },

    locationIcon: {
        height: 24,
        minWidth: 24,
    },

}));
